import NavigationSections from './NavigationSections';

export default NavigationSections;
export { NavigationSections };
